//import flatpickr from 'flatpickr';
//import { German } from 'flatpickr/dist/l10n/de';

const FORM_DEFAULT = document.querySelector('.ce--form_formframework form');
const FORM_EVENTS = document.querySelector('.tx-sf-event-mgt form');
const FORM_FILTER = document.querySelector('form.vd-form.vd-filter');
const FORM_JOB_BOARD = document.querySelector('form.tx_vdjobboard');

const DATE_INPUTS_DEFAULT = FORM_DEFAULT ? FORM_DEFAULT.querySelectorAll('input[type="date"]') : [];
const DATE_INPUTS_EVENTS = FORM_EVENTS ? FORM_EVENTS.querySelectorAll('input[type="date"]') : [];
const DATE_INPUTS_FILTER = FORM_FILTER ? FORM_FILTER.querySelectorAll('input[type="date"]') : [];
const DATE_INPUTS_JOB_BOARD = FORM_JOB_BOARD
  ? FORM_JOB_BOARD.querySelectorAll('input[type="date"]')
  : [];

const DATE_INPUTS = [
  ...DATE_INPUTS_DEFAULT,
  ...DATE_INPUTS_EVENTS,
  ...DATE_INPUTS_FILTER,
  ...DATE_INPUTS_JOB_BOARD,
];

DATE_INPUTS.forEach((el) => {
  /**
	 * var flatpickr_options = {
		ariaDateFormat: 'Y-m-d',
		enableTime: false,
		position: 'below',
		clickOpens: false,
		inline: true,
		minTime: "09:00",
		maxTime: "15:00",
		weekNumbers: false,
		minDate: tomorrow,
		maxDate: endDate,
		disable: [],
		defaultHour: 10,
		defaultMinute: 0,
		minuteIncrement: 30,
		locale: "de",
		time_24hr: true,
		onChange: function(selectedDates, dateStr, instance) {
	
		}
	
	};
	 */

  let today = new Date();

  let options = {
    locale: window.flatpickrGerman,
    enableTime: false,
    dateFormat: 'd.m.Y',
    allowInput: true,
    disableMobile: true, // added for ios BUG
    onOpen: [
      (selectedDates, dateStr, instance) => {
        let restrictDateFieldsToday = [
          'offerAssistant-institution-expirationDate',
          'offerAssistant-institution-publicationDate',
          'offerAssistant-institution-startDate',
          'offerFurtherTraining-institution-expirationDate',
          'offerFurtherTraining-institution-publicationDate',
          'offerFurtherTraining-institution-startDate',
          'offerMfa-institution-expirationDate',
          'offerMfa-institution-publicationDate',
          'offerMfa-institution-startDate',
          'offerTrainee-institution-expirationDate',
          'offerTrainee-institution-publicationDate',
          'offerTrainee-institution-startDate',
        ];
        restrictDateFieldsToday.forEach(function (identifier) {
          if ($(instance.element).attr('id') === identifier) {
            document.querySelector('#' + identifier)._flatpickr.set('minDate', new Date());
          }
          
/*
            if ('ontouchstart' in window || navigator.maxTouchPoints) {
                instance.element.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                    inline: "nearest"
                });
            }
            else {
                return
            }
*/
            
        });
        
        
        
      },
    ],
    onClose: [
      (selectedDates, dateStr, instance) => {
        // console.log('close datepicker');
        // instance.calendarContainer.setAttribute('tabindex', "-1");
        // instance.monthElements[0].setAttribute('tabindex', "-1");
        // instance.currentYearElement.setAttribute('tabindex', "-1");
      },
    ],
    onChange: [
      (selectedDates, dateStr, instance) => {
        if (
          $(instance.element).attr('id') === 'dateFrom' &&
          $(typeof $('#dateTo') !== 'undefined')
        ) {
          let selectedDate = instance.selectedDates[0];
          document.querySelector('#dateTo')._flatpickr.set('minDate', selectedDate);
        }
      },
    ],
  };

  if (el.value !== '') {
    options.defaultDate = el.value;
  }

  const targetNode = document.getElementById('plugin-directories_veranstaltungen-list');
  const config = { attributes: false, childList: true, subtree: true };

  const callback = (mutationList, observer) => {
    for (const mutation of mutationList) {
      if (mutation.type === 'childList') {
        console.log(mutation);
        console.log(el);
        console.log(options);

        mutation.addedNodes.forEach((node) => {
          console.log(el);
          if (node.nodeName === 'FORM' && node.classList.contains('refreshed')) {
            node.classList.remove('refreshed');
            console.log('----');
            console.log(el);
            flatpickr(DATE_INPUTS_DIRECTORIES, options);
          }
        });
      }
    }
  };
  //const observer = new MutationObserver(callback);
  //observer.observe(targetNode, config);

  window.flatpickr(el, options);
});
